import { render, staticRenderFns } from "./addwenwu.vue?vue&type=template&id=71ecc52c&scoped=true&"
import script from "./addwenwu.vue?vue&type=script&lang=js&"
export * from "./addwenwu.vue?vue&type=script&lang=js&"
import style0 from "./addwenwu.vue?vue&type=style&index=0&id=71ecc52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ecc52c",
  null
  
)

export default component.exports